var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCheckNotSel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-check 1",
    clipPath: "url(#clip0_5120_3300)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 21.3941V19.3941C16.5 18.3332 16.0786 17.3158 15.3284 16.5657C14.5783 15.8155 13.5609 15.3941 12.5 15.3941H5.5C4.43913 15.3941 3.42172 15.8155 2.67157 16.5657C1.92143 17.3158 1.5 18.3332 1.5 19.3941V21.3941",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 11.3941C11.2091 11.3941 13 9.60324 13 7.3941C13 5.18496 11.2091 3.3941 9 3.3941C6.79086 3.3941 5 5.18496 5 7.3941C5 9.60324 6.79086 11.3941 9 11.3941Z",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.5 11.3941L19.5 13.3941L23.5 9.3941",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5120_3300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.394104)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheckNotSel);
export default __webpack_public_path__ + "static/media/UserCheckNotSel.f0dbbcb061a369a4df731277ab4f31b9.svg";
export { ForwardRef as ReactComponent };